module.exports = __webpack_public_path__ + "static/media/house1.af76b7d9.webp";